import { z } from 'zod';

import { shared } from '@tig-dpqa-cloud/contract-backend-common';

export const CloudEventsCredentialsSchema = shared.AWSCredentials.extend({
  queueUrl: z.string().min(1),
  expiration: z.iso.datetime({ offset: true }).describe('The expiration date of the credentials'),
});

export type CloudEventsCredentials = z.infer<typeof CloudEventsCredentialsSchema>;
